import { register } from 'async-ops';
import { callMdaePublicApi } from "../../../call-web-api";

export const GET_USER_DOCUMENT_CATEGORY_LIST = 'GET_USER_DOCUMENT_CATEGORY_LIST';

export const service = async () => {
  const response: any = await callMdaePublicApi({
    type: 'GET',
    contentType: 'application/json',
    url: '/private/v1/documents/documentcategories'
  })
  return response;
};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(GET_USER_DOCUMENT_CATEGORY_LIST, service, mock);
